import React from 'react'
import styles from './button.module.scss'

export default function Button({children, onClick, className = ''}: {children: React.ReactNode, onClick?: () => void, className?: string}) {
    return (
        <div className={`${styles.container} animated ${onClick && 'click'} ${className}`} onClick={onClick}>
            {children}
        </div>
    )
}